import { UI } from "../constants/tokens";
import { fmtPct, shownMoneyDir } from "../utils/formatters";
import DualMoney, { IlsSinceSlot } from "./DualMoney";
import { useFxRates } from "../utils/fxRates";
import Money from "./Money";

// ─── A change on the portfolio card, as one unit (sprint 17) ─────────────────
// "מאז רכישה" and "שינוי יומי" / "יום המסחר האחרון": the label, then on one
// line the pill ("+$8,317.00 · +22.47%") and the shekels beside it, all
// aligned to the same start edge. One component for the home card and the
// portfolio card, so the two read the same.
//
// The pill: solid ground (--si-gain-soft / --si-loss-soft), the figure in the
// rise/fall colour, the sign always there · colour is never the only cue.
export function MovePill({ dollar, pct, cur, size = 15, whole = false }) {
  // Subscribed, so the colour follows when a rate arrives (shownMoneyDir
  // reads the same store).
  useFxRates();
  const dir = shownMoneyDir(dollar, cur, whole ? 0 : null);
  const color = dir > 0 ? UI.gain : dir < 0 ? UI.loss : UI.text.primary;
  return (
    <span dir="ltr" className="si-num" data-move-pill style={{
      display: "inline-flex", alignItems: "baseline", gap: 6, whiteSpace: "nowrap",
      background: dir > 0 ? UI.gainSoft : dir < 0 ? UI.lossSoft : UI.fill.subtle,
      borderRadius: 999, padding: `${Math.round(size * 0.35)}px ${Math.round(size * 0.75)}px`,
      fontSize: size, fontWeight: 700, color, unicodeBidi: "isolate",
    }}>
      {/* A portfolio-level sum: whole units, "+$8,317" (DECISIONS, sprint 17). */}
      <Money value={dollar} cur={cur} size={size} weight={700} color={color} signed decimals={whole ? 0 : null}/>
      {pct != null && <><span aria-hidden="true">·</span><span>{fmtPct(pct)}</span></>}
    </span>
  );
}

// `ilsSince` / `ilsCaption`: a gain since purchase, whose shekels come only
// from the purchase-day rate (utils/purchaseFx.js, shekelSince). With shekels
// as the display currency the pill itself waits for them or shows "—".
export default function HeroChange({ label, info = null, dollar, pct, cur, ils = null, ilsNote = null, size = 15, ilsSince = null, ilsCaption = null }) {
  useFxRates();
  const dir = shownMoneyDir(dollar, cur, 0);
  return (
    <div data-hero-change style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 6 }}>
      {/* The label grows with the figure (26/10/2026: 13 at 15, 17 at 20). */}
      <span style={{ fontSize: Math.max(13, Math.round(size * 0.85)), color: UI.text.secondary, display: "inline-flex", alignItems: "center", gap: 6 }}>
        {label}{info}
      </span>
      <DualMoney usd={dollar} cur={cur} size={size} signed inline ils={ils} ilsNote={ilsNote}
        ilsSince={ilsSince} ilsCaption={ilsCaption}
        color={dir > 0 ? UI.gain : dir < 0 ? UI.loss : UI.text.primary}>
        <IlsSinceSlot since={cur === "ILS" ? ilsSince : null} size={size} caption={cur === "ILS" ? ilsCaption : null}>
          <MovePill dollar={dollar} pct={pct} cur={cur} size={size} whole/>
        </IlsSinceSlot>
      </DualMoney>
    </div>
  );
}
